import { createReducer } from 'typesafe-actions'
import { setExcludeAudiExclusiveSelectionState } from '../actions/app/configuration.actions'

export const defaultState: string[] = []

const excludeAudiExclusiveSelectionReducer = createReducer(defaultState)
    .handleAction(setExcludeAudiExclusiveSelectionState, (state, action) => action.payload)

export default excludeAudiExclusiveSelectionReducer
